import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Csv = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="csv icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.82843C3 6.29799 3.21071 5.78929 3.58579 5.41421L8.41421 0.585787C8.78929 0.210714 9.29799 0 9.82843 0L19 0C20.1046 0 21 0.895431 21 2V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V6.82843ZM10 7V2.5L5.5 7H10ZM8.22309 16.3288C9.24396 16.3288 9.94917 15.805 10.1708 14.905L9.38501 14.7035C9.20367 15.1804 8.87457 15.5229 8.22309 15.5229C7.49773 15.5229 6.88655 15.0125 6.88655 13.9244C6.88655 12.8364 7.49773 12.3259 8.22309 12.3259C8.87457 12.3259 9.20367 12.6685 9.38501 13.1453L10.1708 12.9438C9.94917 12.0439 9.24396 11.52 8.22309 11.52C7.04774 11.52 6 12.3528 6 13.9244C6 15.496 7.04774 16.3288 8.22309 16.3288ZM12.2863 16.3288C13.1662 16.3288 13.7908 15.7848 13.7908 14.9251C13.7908 14.1326 13.2736 13.817 12.7229 13.5617L12.6724 13.5386C12.208 13.3263 11.7826 13.1317 11.7826 12.7558C11.7826 12.5073 12.0042 12.3259 12.2595 12.3259C12.5348 12.3259 12.7565 12.4536 12.8841 12.8229L13.5893 12.373C13.3609 11.8289 12.9244 11.52 12.2595 11.52C11.4804 11.52 10.9498 12.0707 10.9498 12.7826C10.9498 13.4811 11.3796 13.8438 11.8363 14.0722C11.9019 14.105 11.9672 14.1367 12.0314 14.1679L12.0314 14.1679L12.0317 14.168L12.0318 14.1681C12.5062 14.3987 12.9177 14.5987 12.9177 14.9654C12.9177 15.3617 12.6557 15.5229 12.3065 15.5229C11.7893 15.5229 11.5072 15.0931 11.3729 14.5692L10.6677 15.0125C10.8155 15.7311 11.4334 16.3288 12.2863 16.3288ZM17.0329 11.5737H18L16.4217 16.2751H15.5351L13.9568 11.5737H14.9239L15.9784 15.0528L17.0329 11.5737Z"
    />
  </svg>
)
